import {
	RETIREMENT_LOAN_AMOUNT_DEFAULT,
	RETIREMENT_LOAN_DEFAULT_YEARS_AHEAD,
	RETIREMENT_LOAN_KIND_VALUES,
} from "web_myplann/Inspiration/Retirement/constants";
import type { RetirementLoanFormModel } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

export const getRetirementLoanDefaults = (
	retirementYear: number,
	currentYear: number,
): RetirementLoanFormModel => ({
	kind: RETIREMENT_LOAN_KIND_VALUES[0],
	amount: RETIREMENT_LOAN_AMOUNT_DEFAULT,
	endYear: Math.min(
		retirementYear,
		currentYear + RETIREMENT_LOAN_DEFAULT_YEARS_AHEAD,
	),
});
